
import { FormsFeatureContext } from '@ngt/forms';
import { useCallback, useContext } from 'react';
import { LotPostBulkUpdateCoordsByStageId, LotPostBulkUpdateCoordsByStageIdResponse } from '../../api/dtos';

export const usePostLotBulkUpdateCoords = () => {
    const formsFeature = useContext(FormsFeatureContext);


    // @ts-ignore
    const save = useCallback(async (stageId: number, lots: Lot[]) => {
        if(!stageId) return false;
        const response: LotPostBulkUpdateCoordsByStageIdResponse = await formsFeature.serviceStackClient.post(new LotPostBulkUpdateCoordsByStageId({ stageId: stageId, lots: lots}))

        return response.responseStatus;
    }, [formsFeature.serviceStackClient]);

    return save;
};

export default usePostLotBulkUpdateCoords;